<template>
  <div class="container">
    <div>
      <gl-button @click="$refs.file.click()" :disabled="disabled">
        {{ buttonText }}
      </gl-button>
    </div>
    <div>
      {{ filename }}
    </div>

    <!-- ファイル選択の表示は隠して、他トリガーからファイル選択ダイアログは起動します -->
    <input
      type="file"
      ref="file"
      accept=".txt,.text,.csv,.dat"
      hidden
      @change="upload($event.target.files)"
    />
    <md-snackbar
      md-position="center"
      :md-duration="snackbar.duration"
      :md-active.sync="snackbar.show"
      md-persistent
    >
      <span>{{ snackbar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
const STATE_DEFAULT = 'DEFAULT'
const STATE_UPLOADING = 'UPLOADING'

const BUTTON_TEXT = {
  [STATE_DEFAULT]: 'ファイル読込',
  [STATE_UPLOADING]: 'アップロード中…',
}

export default {
  props: {
    fileLoadFunction: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      file: null,
      state: STATE_DEFAULT,
      /**
       * Snackbarプロパティ
       */
      snackbar: {
        show: false,
        duration: 4000,
        message: '',
      },
    }
  },
  computed: {
    disabled() {
      return this.state !== STATE_DEFAULT
    },
    buttonText() {
      return BUTTON_TEXT[this.state]
    },
    filename() {
      return this.file ? this.file.name : ''
    },
  },
  methods: {
    async upload(files) {
      if (files.length === 0) {
        return
      }

      this.file = files[0]

      try {
        this.state = STATE_UPLOADING
        await this.toResourceId(this.file)
      } finally {
        this.state = STATE_DEFAULT
        this.$refs.file.value = ''
      }
    },
    /**
     * 選択ファイルをサーバーにアップロードしてリソースID
     * を取得して処理をする
     */
    async toResourceId(file) {
      const repo = this.$repositories.get('uploadFile')

      const { url, id } = await repo.issueUploadUrl(file.name)
      await repo.upload(url, file)

      let loadResult
      try {
        loadResult = await this.fileLoadFunction(id)
      } catch (error) {
        // ファイルダイアログで拡張子を絞っていますが、
        // ユーザーが手動で「全てのファイル」に変更して選択できる
        // ので、このエラーは発生する可能性があります。
        if (
          error.response.status === 400 &&
          error.response.data.code === 'NOT_SUPPORTED'
        ) {
          const msg =
            `アップロードされたファイルが解析できませんでした。` +
            `サポートされている形式のファイルかご確認ください（${
              error.response.data.supported
            }）。`
          alert(msg)
          return
        }
        throw error
      }

      const loadStats = loadResult
        ? `ロード件数: ${loadResult.statistics.loaded}`
        : 'アップロード情報が取得できませんでした'

      this.showSnackbar({
        message: `アップロードが完了しました（${file.name}, ${loadStats}）。`,
      })

      this.$emit('loaded', { loadResult, filename: file.name })
    },
    /**
     * Snackbarの表示
     */
    showSnackbar({ message, duration }) {
      this.snackbar.duration = duration || 4000
      this.snackbar.message = message
      this.snackbar.show = true
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
}
</style>
